 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"c24a7fba1b99f5d80b50c0c30b68044e978c8030","11":"3d900bdb8e1f0e2108d205af384a11688c946059","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"bc62dab504a71ef8c5d240a105694d09627f06f3","14":"component---src-pages-integration-builder-sections-card-generator-tsx","15":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","17":"11e8d57d","19":"4b80be75","20":"5cf42e9e","21":"962beaf7","23":"component---src-pages-404-js","24":"component---src-pages-banner-js","25":"component---src-pages-build-better-js","26":"component---src-pages-classic-home-js","27":"component---src-pages-docs-template-js","28":"component---src-pages-integration-builder-index-tsx","29":"component---src-pages-integration-builder-sections-build-tsx","30":"component---src-pages-integration-builder-sections-code-tsx","31":"component---src-pages-integration-builder-sections-configure-tsx","32":"component---src-pages-integration-builder-sections-demo-tsx","33":"component---src-pages-integration-builder-sections-help-modal-tsx","34":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","35":"component---src-pages-integration-builder-sections-preview-tsx","36":"component---src-pages-integration-builder-sections-take-live-tsx","37":"component---src-pages-internal-js","38":"component---src-pages-signup-js","39":"component---src-pages-signupauto-js","40":"component---src-pages-support-js","41":"component---src-pages-thankyou-js","42":"component---src-pages-unsubscribe-js","43":"component---src-pages-video-collection-tsx","44":"component---src-pages-video-home-tsx","45":"component---src-pages-video-watch-tsx","46":"component---src-templates-template-layout-js","47":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"03e26d6c68adf28137b1","2":"7ffbc94115aa4dfa04fa","3":"1a64da34a55b9a082d6f","4":"219a09b12fbf04467e9f","5":"0747ebf1c29a652cf4df","6":"b2b72e861f2449c1fffa","7":"e532302b7cdb7e89753f","8":"01bb6b3c0816b90d6e27","9":"af6d817f76e25b69d936","10":"2d2d6218c224a23fed7e","11":"3b556eb8ce94785de06e","12":"0a67c823eacb4b56edf3","13":"2da9ba4b79989b711bc5","14":"89d3a89f9208b609c9bf","15":"a704365c56a1a264a9aa","17":"09f2bc41f7b3930f78ec","19":"b30924bd4349ce9fa309","20":"35ffdc8354f03469e137","21":"9df059f86195f22aa238","23":"40547c64e7c66a930af2","24":"ada406f27b39066f4dea","25":"4faa54cc54f282f2481d","26":"352211e07849888eb46c","27":"6377607faff9f45e196d","28":"afaef15700b2754f9c13","29":"5a625b20ec2dcb4f36d0","30":"1aad89a3a0e7cf693f3d","31":"fcda721acbb63eba4246","32":"89be20770aa4334ecab7","33":"a05fc390120d204f0222","34":"0beeac46fae6949f0831","35":"99dc30d903ab94c42bbf","36":"bf201a3fd53c736ab683","37":"17ba69147229e7ad29d9","38":"9a7219d46ab14581383a","39":"931239789c2488a9a9e7","40":"cf82cf808ff753b81f54","41":"5fd8e9cce07fe5fed69f","42":"423e996b5dd86e7db8c6","43":"8d26d8de42951d750a43","44":"a824ec06555b38822301","45":"14a5abbfced413123184","46":"2002a10ff71148809a31","47":"0feb31c39e327491e2d3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8fb5dbc09e506c70258e16b6e48c6a5b1195e539","2":"5ba45f63acdc5aca112f26883a7e051cb76ebc81","3":"1bc699b90fe94e7c2de1031992cde3a4b2a67425","4":"953529affb241643b097b7a172547e8e588c10b7","5":"framework","6":"33ce6ab0","7":"4c355f13","8":"c05b8182","9":"component---src-pages-layout-js","10":"c24a7fba1b99f5d80b50c0c30b68044e978c8030","11":"3d900bdb8e1f0e2108d205af384a11688c946059","12":"3f985f62e6c52f7e8bc97d6e9a76b184f2711dc4","13":"bc62dab504a71ef8c5d240a105694d09627f06f3","14":"component---src-pages-integration-builder-sections-card-generator-tsx","15":"d5ceeaead26c68f645dc39122ccc1b9861fd8433","17":"11e8d57d","19":"4b80be75","20":"5cf42e9e","21":"962beaf7","23":"component---src-pages-404-js","24":"component---src-pages-banner-js","25":"component---src-pages-build-better-js","26":"component---src-pages-classic-home-js","27":"component---src-pages-docs-template-js","28":"component---src-pages-integration-builder-index-tsx","29":"component---src-pages-integration-builder-sections-build-tsx","30":"component---src-pages-integration-builder-sections-code-tsx","31":"component---src-pages-integration-builder-sections-configure-tsx","32":"component---src-pages-integration-builder-sections-demo-tsx","33":"component---src-pages-integration-builder-sections-help-modal-tsx","34":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","35":"component---src-pages-integration-builder-sections-preview-tsx","36":"component---src-pages-integration-builder-sections-take-live-tsx","37":"component---src-pages-internal-js","38":"component---src-pages-signup-js","39":"component---src-pages-signupauto-js","40":"component---src-pages-support-js","41":"component---src-pages-thankyou-js","42":"component---src-pages-unsubscribe-js","43":"component---src-pages-video-collection-tsx","44":"component---src-pages-video-home-tsx","45":"component---src-pages-video-watch-tsx","46":"component---src-templates-template-layout-js","47":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"533c6e81befda1406253","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/migrationv1/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
